module.exports = __webpack_public_path__ + "img/dash-square.0eceee5b.svg";